import { Component, ComponentRef, Input, OnInit, Sanitizer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogRef, NbDialogService } from '@nebular/theme';

@Component({
  selector: 'ngx-how-to-modal',
  templateUrl: './how-to-modal.component.html',
  styleUrls: ['./how-to-modal.component.scss']
})
export class HowToModalComponent implements OnInit {

  constructor(private dialogService: NbDialogService
  ) { }

  @Input() helpLabel: any;
  @Input() link: string;

  public isModal = false;

  ngOnInit(): void {
  }

  onPlayedClick(): void {
    const ref: ComponentRef<HowToModalComponentDialog> =
      this.dialogService.open(HowToModalComponentDialog, {
        closeOnBackdropClick: true,
        closeOnEsc: true,
        autoFocus: false,
        context: {
          link: this.link,
          helpLabel: this.helpLabel
        },
      }).componentRef;

  }


}


@Component({
  selector: 'ngx-how-to-modal-dialog',
  templateUrl: './how-to-modal.component.html',
  styleUrls: ['./how-to-modal.component.scss']
})
export class HowToModalComponentDialog implements OnInit {

  public safeUrl:any;
  public isModal = true;
  @Input() helpLabel: any;
  @Input() link: string;


  constructor(private nbDialogService: NbDialogService,
    private dialogRef: NbDialogRef<HowToModalComponentDialog>,
    private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.link
    );
    



  }




  onClose(): void {
    this.dialogRef.close();
  }

}


